import React from "react";
import PropTypes from "prop-types";

import Card from "./Card";
import { useShowSuitTitleOnCards } from "../../modules/deck/selectors";

// A card of the game's own deck: shows the suit title when the deck has it turned on, and
// otherwise keeps it as screen-reader text.
const GameCard = ({ suitTitle, ...cardProps }) => {
  const showSuitTitle = useShowSuitTitleOnCards();

  return <Card {...cardProps} suitTitle={showSuitTitle ? suitTitle : null} suitLabel={suitTitle} />;
};

GameCard.propTypes = {
  suitTitle: PropTypes.string,
};

export default GameCard;
